<template>
<div style="margin: 0 50px;">
  <div>
    <div style="width: calc(100% - 75px);float: left">
      <el-input size="mini" v-model="phone" placeholder="添加新号码" @blur="levelPhone()"></el-input>
    </div>
    <div style="width: 75px;text-align: right;float: right">
      <el-button size="mini" type="primary" plain @click="addPhone()">添加</el-button>
    </div>
    <div style="clear:both;"></div>
    <div style="height: 20px;font-size: 14px">
      <span style="color: red">{{hit}}</span>
    </div>
  </div>
  <div style="max-height: 300px">
    <el-table
      :data="showTable"
      size="mini"
      border
      style="width: 100%"
      highlight-current-row
      ref="singleTable">
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="联系方式"
        min-width="100"
        align="center">
        <template slot-scope="scope">
          <span>{{scope.row.phone}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createtime"
        label="创建时间"
        width="140"
        align="center">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="80"  class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delPhone(scope.$index, scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="height: 20px"></div>
</div>
</template>

<script>
import {addpersonotherphone, querypersonotherphone, deletepersonotherphone} from '../../../../api/serviceObject'

export default {
  name: 'mornPhone',
  props: {
    phoneObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      phone: '',
      hit: '',
      showTable: [
        {phone: '13544', show: true},
        {phone: '42636', show: true}
      ]
    }
  },
  created () {
    this.getPhoneTable()
  },
  methods: {
    // 获取表格
    getPhoneTable () {
      let data = {
        pid: this.phoneObj.personRow.id
      }
      querypersonotherphone(data).then(res => {
        this.showTable = res.data.phones
      }).catch(() => {})
    },
    levelPhone () {
      if (this.phone !== '') {
        this.hit = ''
      } else {
        this.hit = '请输入号码'
      }
    },
    addPhone () {
      if (this.phone === '') {
        this.hit = '请输入号码'
        return
      }
      let data = {
        pid: this.phoneObj.personRow.id,
        phone: this.phone + ''
      }
      addpersonotherphone(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功添加号码',
          type: 'success',
          duration: 2000
        })
        this.getPhoneTable()
      }).catch(() => {})
      this.phone = ''
    },
    delPhone (index, row) {
      // this.showTable.splice(index, 1)
      let data = {
        pid: this.phoneObj.personRow.id,
        phoneids: [row.id]
      }
      this.$confirm('此操作将永久删除该【' + row.phone + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        deletepersonotherphone(data).then(res => {
          this.$notify({
            title: '成功',
            message: '成功删除号码',
            type: 'success',
            duration: 2000
          })
          this.getPhoneTable()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/quick/components/mornPhone.vue